import { colors } from './colors';
import { shades } from './shades';

export const designSystemTokens = { colors, shades };
